import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding: 40px 20px;
  background: transparent;
  scroll-margin-top: 100px;
  
  @media (max-width: 960px) {
    padding: 30px 16px;
  }
`

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1100px;
  gap: 12px;
`

const Title = styled.div`
  font-family: 'Mosca Laroke', 'Playfair Display', 'Bodoni Moda', 'Cinzel', serif;
  font-size: 76px;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  line-height: 1;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 20px;
  letter-spacing: 0.5px;

  @media (max-width: 1400px) { font-size: 64px; }
  @media (max-width: 1200px) { font-size: 52px; }
  @media (max-width: 768px)  { font-size: 44px; }
`;

const ComingSoonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 24px;
  background: ${({ theme }) => theme.card};
  border-radius: 16px;
  border: 1.5px dashed ${({ theme }) => theme.primary + '88'};
  max-width: 650px;
  width: 100%;
  gap: 12px;
  box-shadow: rgba(23, 92, 230, 0.1) 0px 4px 20px;
  
  @media (max-width: 768px) {
    padding: 20px 16px;
  }
`

const ComingSoonIcon = styled.div`
  font-size: 36px;
  animation: bounce 2s ease-in-out infinite;
  
  @keyframes bounce {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-6px);
    }
  }
`

const ComingSoonTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: ${({ theme }) => theme.primary};
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 20px;
  }
`

const ComingSoonText = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.text_secondary};
  text-align: center;
  line-height: 1.5;
  margin: 0;
  max-width: 520px;
  
  @media (max-width: 768px) {
    font-size: 13px;
  }
`

const FeatureList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-top: 10px;
`

const FeatureTag = styled.div`
  background: ${({ theme }) => theme.primary + 15};
  border: 1px solid ${({ theme }) => theme.primary + 50};
  color: ${({ theme }) => theme.text_primary};
  padding: 5px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
`

const Blog = () => {
  return (
    <Container id="blog">
      <Wrapper>
        <Title>BLOG & TECHNICAL WRITING</Title>

        <ComingSoonContainer>
          <ComingSoonIcon>📝</ComingSoonIcon>
          <ComingSoonTitle>Coming Soon!</ComingSoonTitle>
          <ComingSoonText>
            I'm currently working on creating in-depth technical articles, case studies,
            and tutorials. Stay tuned for insights on data science, machine learning,
            and software engineering best practices!
          </ComingSoonText>

          <FeatureList>
            <FeatureTag>📚 Technical Articles</FeatureTag>
            <FeatureTag>💡 Case Studies</FeatureTag>
            <FeatureTag>🎓 Tutorials</FeatureTag>
            <FeatureTag>🔬 Research Papers</FeatureTag>
          </FeatureList>
        </ComingSoonContainer>
      </Wrapper>
    </Container>
  )
}

export default Blog
